<template>
    <div class="my-connections-list-filter">
        <common-filter
            :title="$t('pages.network.connections.filters.title')"
            :options="filterOptions"
            @filter-changed="filterChange"
        ></common-filter>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                filterOptions: [
                    { label: this.$t('pages.network.connections.filters.pending_confirmation'), value: true },
                    { label: this.$t('pages.network.connections.filters.in_my_network'), value: true },
                ],
            }
        },

        methods: {
            filterChange(options) {
                this.filterOptions = options

                this.$router.push({
                    ...this.$route,
                    query: { ...this.$route.query, status: this.getStatusByFilterOptions() },
                })
            },

            getStatusByFilterOptions() {
                if (this.filterOptions.every((option) => option.value === true)) return 'all'
                else if (this.filterOptions[0].value === true) return 'unfinished'
                else if (this.filterOptions[1].value === true) return 'finished'
                return null
            },

            resetFilter() {
                this.filterOptions = this.filterOptions.map((option) => {
                    option.value = true
                    return option
                })
                this.$router.push({
                    ...this.$route,
                    query: { ...this.$route.query, status: 'all' },
                })
            },
        },
    }
</script>
